import {View} from 'react-native';

import styled from '../../../lib/utils/styled';

export const BodyContainer = styled(View)({
  marginHorizontal: 30,
  marginTop: 80,
});
